import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getXAxisMinDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateXAxisMin = currTemplateLinePlotSettings?.xAxisMin;
  const newTemplateXAxisMin = currWorkspaceLinePlotSettings?.xAxisMin;

  return {
    label: 'X axis min',
    field: 'xAxisMin' as keyof LinePlotTemplateSettings,
    currValue: currTemplateXAxisMin,
    currDisplayValue:
      currTemplateXAxisMin == null
        ? undefined
        : currTemplateXAxisMin.toString(),
    newValue: newTemplateXAxisMin ?? DEFAULT_LINE_PLOT_SETTINGS.xAxisMin,
    newDisplayValue:
      newTemplateXAxisMin == null ? undefined : newTemplateXAxisMin.toString(),
  };
};
